// Generated by docs/legal/build.mjs from docs/legal/*.md. Do not edit by hand:
// change the reference texts there and rebuild, so all four apps stay in step.
import { OPERATOR_CONTACT, OPERATOR_NAME } from "./legalConfig";
import type { PrivacyPolicy } from "./privacyPolicy";

export const privacyRu: PrivacyPolicy = {
  title: `Политика конфиденциальности`,
  updated: `Редакция от 23 сентября 2026 г.`,
  intro: [
      `Lexibit: тренажёр слов для изучения иностранных языков.`,
      `Приложение работает как сайт, как приложение на домашнем экране и внутри мессенджеров, где оно подключено (например, в Telegram). Эта политика объясняет, какие данные мы обрабатываем, зачем и как вы можете ими управлять.`,
      `Приложением можно пользоваться без аккаунта. Пока вы не вошли, ваши записи хранятся только на вашем устройстве. К нам может попадать лишь статистика использования, о ней ниже.`,
    ],
  sections: [
    {
      heading: `Оператор`,
      paragraphs: [
        `Оператор персональных данных: ${OPERATOR_NAME} (далее «мы»). По любым вопросам о данных пишите на ${OPERATOR_CONTACT}.`,
      ],
    },
    {
      heading: `Данные на устройстве`,
      paragraphs: [
        `Слова, колоды, расписание повторений, история ответов и настройки (языки, тема) хранятся в памяти браузера на этом устройстве.`,
        `Без аккаунта это единственная копия: если очистить данные сайта или удалить приложение, она исчезнет, и восстановить её мы не сможем. Чтобы не потерять данные, сохраняйте резервную копию через экспорт.`,
      ],
    },
    {
      heading: `Вход в аккаунт`,
      paragraphs: [
        `Вход необязателен. Он нужен, чтобы одни и те же данные были доступны на всех ваших устройствах.`,
        `Войти можно через Telegram, а внутри поддерживаемых платформ также через их аккаунт (VK, MAX, LINE, Discord, Microsoft Teams). Отдельного пароля или адреса почты в приложении нет.`,
        `От платформы мы получаем идентификатор вашего аккаунта и, если платформа их передаёт, имя, имя пользователя, ссылку на фото профиля и язык. Мы проверяем подпись платформы и сохраняем эти данные, чтобы создать аккаунт, показывать, под каким аккаунтом вы вошли, и связывать ваши устройства и способы входа. Ещё мы сохраняем, когда вы дали согласие на вход, с какой платформы и когда входили последний раз, а также ваш часовой пояс, чтобы присылать уведомления в подходящее время.`,
        `Номер телефона, контакты, переписку и пароли от платформ мы не получаем. Доступа к вашему аккаунту на платформе у нас нет, и от вашего имени ничего не публикуется.`,
      ],
    },
    {
      heading: `Данные на сервере`,
      paragraphs: [
        `После входа слова, колоды, расписание повторений и история ответов хранятся на нашем сервере и синхронизируются между устройствами. Доступ к ним есть только у вашего аккаунта.`,
        `Если вы занимаетесь с преподавателем, он видит выданные вам колоды и задания и получает уведомление, когда вы присоединились и когда выполнили задание. Если вы делитесь подборкой слов или вызовом по ссылке, их видят все, у кого есть ссылка; ссылка действует 30 дней.`,
      ],
    },
    {
      heading: `Статистика использования`,
      paragraphs: [
        `Только если вы разрешили это в настройках, приложение отправляет нам события: какие экраны открываются и удаются ли ключевые действия. Событие содержит случайный идентификатор устройства и время; если вы вошли, мы связываем его с вашим аккаунтом. Содержимое ваших записей в статистику не попадает. Отключить статистику можно в любой момент там же, и тогда неотправленные события удаляются.`,
        `Мы используем статистику, чтобы находить ошибки и понимать, какие функции полезны.`,
        `Сторонних систем аналитики и рекламы в приложении нет.`,
      ],
    },
    {
      heading: `Уведомления`,
      paragraphs: [
        `Если вы вошли через Telegram и запускали нашего бота, бот может присылать напоминания о повторениях и недельную сводку, а «слово дня» только если вы включили его в настройках. Преподавателю бот сообщает о действиях его учеников.`,
        `Чтобы не получать сообщения бота, остановите или заблокируйте его в Telegram.`,
        `Если вы разрешите уведомления в браузере, мы сохраним данные подписки (адрес для доставки, ключи шифрования, тип браузера и язык) и будем отправлять уведомления через сервис push-уведомлений вашего браузера. Отключить их можно в настройках браузера или устройства.`,
      ],
    },
    {
      heading: `Правовые основания`,
      paragraphs: [
        `Мы обрабатываем персональные данные в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных»:`,
        `• данные аккаунта и синхронизируемые записи: чтобы предоставлять сервис по Условиям использования и на основании согласия, которое вы даёте при входе;`,
        `• статистику: на основании согласия, которое вы включаете в настройках;`,
        `• уведомления: на основании вашего согласия, которое вы даёте, запуская бота или разрешая уведомления в браузере.`,
        `Согласие можно отозвать в любой момент: отключить статистику и уведомления, удалить аккаунт или написать нам. Отзыв согласия не делает незаконной обработку, которая велась до него.`,
      ],
    },
    {
      heading: `Место и сроки хранения`,
      paragraphs: [
        `Сервис работает на арендованном нами сервере с собственной установкой базы данных; сторонние облачные платформы для бэкенда мы не используем. Каждый час делается резервная копия базы. Она шифруется до отправки и хранится в облачном хранилище не дольше 56 дней.`,
        `Данные аккаунта хранятся, пока существует аккаунт. После удаления аккаунта данные сразу удаляются из рабочей базы, а из резервных копий по мере их замены, не позднее чем через 56 дней.`,
      ],
    },
    {
      heading: `Передача данных`,
      paragraphs: [
        `Мы не продаём данные и не передаём их рекламным сетям и брокерам данных. Данные получают только:`,
        `• платформы входа (Telegram, VK, MAX, LINE, Discord, Microsoft): в объёме, нужном для проверки входа; дальше данные обрабатываются по их собственным правилам;`,
        `• Telegram: текст сообщений, которые присылает бот;`,
        `• сервис push-уведомлений вашего браузера (например, Apple, Google или Mozilla): текст уведомления, если вы их включили;`,
        `• ваш преподаватель: сведения о выданных вам колодах и выполнении заданий, если вы занимаетесь с преподавателем;`,
        `• Anthropic, PBC (США), если в приложении доступен ИИ-тьютор и вы им пользуетесь: ваши сообщения тьютору, пара изучаемых языков и список ваших слов. Это трансграничная передача данных; не пишите тьютору личных сведений;`,
        `• хостинг-провайдер и провайдер хранилища резервных копий: они обслуживают инфраструктуру и не вправе использовать данные в своих целях;`,
        `• государственные органы, только по законному требованию.`,
      ],
    },
    {
      heading: `Ваши права`,
      paragraphs: [
        `Вы можете:`,
        `• выгрузить свои данные в файл JSON в настройках;`,
        `• удалить аккаунт вместе с данными на сервере в настройках;`,
        `• удалить данные на устройстве, очистив данные сайта или удалив их в настройках;`,
        `• отозвать согласие, отключить статистику и уведомления;`,
        `• запросить сведения о том, как обрабатываются ваши данные, получить их копию, потребовать исправить или удалить их, написав на ${OPERATOR_CONTACT}. Мы ответим в течение 10 рабочих дней;`,
        `• обжаловать наши действия в Роскомнадзоре или в суде.`,
      ],
    },
    {
      heading: `Возраст`,
      paragraphs: [
        `Приложение не предназначено для детей младше 13 лет, и мы сознательно не собираем их данные. Если вы узнали, что ребёнок передал нам свои данные, напишите нам, и мы их удалим.`,
      ],
    },
    {
      heading: `Изменения политики`,
      paragraphs: [
        `Если мы изменим эту политику, то обновим дату редакции вверху страницы. Если изменения потребуют вашего нового согласия, мы запросим его отдельно.`,
      ],
    },
    {
      heading: `Контакты`,
      paragraphs: [
        `${OPERATOR_NAME}, ${OPERATOR_CONTACT}.`,
      ],
    },
  ],
};

export const privacyEn: PrivacyPolicy = {
  title: `Privacy Policy`,
  updated: `Effective 23 September 2026`,
  intro: [
      `Lexibit is a vocabulary trainer for learning foreign languages.`,
      `It runs as a website, as an app on your home screen, and inside the messengers it is connected to (such as Telegram). This policy explains what data we process, why, and how you can control it.`,
      `You can use the app without an account. Until you sign in, your entries are stored only on your device. The only thing that may reach us is usage statistics, described below.`,
    ],
  sections: [
    {
      heading: `Data controller`,
      paragraphs: [
        `The data controller is ${OPERATOR_NAME} ("we", "us"). For any question about your data, write to ${OPERATOR_CONTACT}.`,
      ],
    },
    {
      heading: `Data on your device`,
      paragraphs: [
        `Your words, decks, review schedule, answer history and settings (languages, theme) are stored in your browser on this device.`,
        `Without an account, this is the only copy. Clearing site data or uninstalling the app deletes it, and we cannot get it back. To avoid losing your data, keep a backup using the export feature.`,
      ],
    },
    {
      heading: `Signing in`,
      paragraphs: [
        `Signing in is optional. It lets you see the same data on all your devices.`,
        `You can sign in with Telegram, or, inside the platforms we support, with that platform's account (VK, MAX, LINE, Discord, Microsoft Teams). The app has no password or email login of its own.`,
        `From the platform we receive your account ID and, where the platform provides them, your name, username, profile photo link and language. We verify the platform's signature and store this data to create your account, show you which account you are signed in with, and link your devices and sign-in methods together. We also store when you agreed to sign in, which platform you used, when you last signed in, and your time zone, so notifications arrive at a sensible time.`,
        `We never receive your phone number, contacts, messages or platform passwords. We have no access to your account on the platform, and nothing is ever posted on your behalf.`,
      ],
    },
    {
      heading: `Data on our server`,
      paragraphs: [
        `Once you sign in, your words, decks, review schedule and answer history are stored on our server and synced between your devices. Only your account can access them.`,
        `If you study with a tutor, they can see the decks and assignments they gave you and are notified when you join and when you complete an assignment. If you share a word collection or a challenge by link, anyone with the link can see it; links expire after 30 days.`,
      ],
    },
    {
      heading: `Usage statistics`,
      paragraphs: [
        `Only if you allow it in Settings, the app sends us events: which screens are opened and whether key actions succeed. Each event contains a random device ID and a timestamp; if you are signed in, we link it to your account. The content of your entries is never included. You can turn statistics off there at any time, and any events not yet sent are deleted.`,
        `We use statistics to find bugs and to understand which features are useful.`,
        `The app contains no third-party analytics or advertising.`,
      ],
    },
    {
      heading: `Notifications`,
      paragraphs: [
        `If you signed in with Telegram and have started our bot, the bot may send you review reminders and a weekly summary, and a "word of the day" only if you turn it on in Settings. Tutors get messages from the bot about their students' activity.`,
        `To stop messages from the bot, stop or block it in Telegram.`,
        `If you allow notifications in your browser, we store the subscription details (delivery address, encryption keys, browser type and language) and send notifications through your browser's push service. You can turn them off in your browser or device settings.`,
      ],
    },
    {
      heading: `Legal basis`,
      paragraphs: [
        `We process personal data in accordance with Russian Federal Law No. 152-FZ of 27 July 2006 on Personal Data:`,
        `• account data and synced entries: to provide the service under the Terms of Use, and on the basis of the consent you give when you sign in;`,
        `• statistics: on the basis of the consent you turn on in Settings;`,
        `• notifications: on the basis of your consent, given when you start the bot or allow notifications in your browser.`,
        `You can withdraw your consent at any time: turn off statistics and notifications, delete your account, or write to us. Withdrawing consent does not make any processing carried out before it unlawful.`,
      ],
    },
    {
      heading: `Storage location and retention`,
      paragraphs: [
        `The service runs on a server we rent, with our own database installation; we do not use third-party cloud backend platforms. The database is backed up every hour. Each backup is encrypted before it leaves the server and kept in cloud storage for no more than 56 days.`,
        `Account data is kept for as long as your account exists. When you delete your account, your data is removed from the live database immediately, and from backups as they are replaced, within 56 days at most.`,
      ],
    },
    {
      heading: `Data sharing`,
      paragraphs: [
        `We do not sell your data or share it with advertising networks or data brokers. Data is shared only with:`,
        `• sign-in platforms (Telegram, VK, MAX, LINE, Discord, Microsoft), to the extent needed to verify your sign-in; from there, their own policies apply;`,
        `• Telegram, which carries the messages our bot sends you;`,
        `• your browser's push service (for example Apple, Google or Mozilla), which carries notification text if you have turned notifications on;`,
        `• your tutor, who sees the decks given to you and whether you completed assignments, if you study with a tutor;`,
        `• Anthropic, PBC (USA), if the AI tutor is available in the app and you use it: your messages to the tutor, the language pair you are learning and your word list. This is a cross-border transfer of data, so please do not share personal details with the tutor;`,
        `• our hosting provider and backup storage provider, who maintain the infrastructure and may not use the data for their own purposes;`,
        `• government authorities, only when legally required.`,
      ],
    },
    {
      heading: `Your rights`,
      paragraphs: [
        `You can:`,
        `• export your data to a JSON file in Settings;`,
        `• delete your account together with the data on our server in Settings;`,
        `• delete the data on your device by clearing site data or in Settings;`,
        `• withdraw your consent and turn off statistics and notifications;`,
        `• ask how your data is processed, get a copy of it, or have it corrected or deleted by writing to ${OPERATOR_CONTACT}. We will reply within 10 working days;`,
        `• complain about our actions to Roskomnadzor (the Russian data protection authority) or to a court.`,
      ],
    },
    {
      heading: `Age`,
      paragraphs: [
        `The app is not intended for children under 13, and we do not knowingly collect their data. If you learn that a child has given us their data, write to us and we will delete it.`,
      ],
    },
    {
      heading: `Changes to this policy`,
      paragraphs: [
        `If we change this policy, we will update the effective date at the top of this page. If a change requires your new consent, we will ask for it separately.`,
      ],
    },
    {
      heading: `Contact`,
      paragraphs: [
        `${OPERATOR_NAME}, ${OPERATOR_CONTACT}.`,
      ],
    },
  ],
};

export const termsRu: PrivacyPolicy = {
  title: `Условия использования`,
  updated: `Редакция от 23 сентября 2026 г.`,
  intro: [
      `Эти условия составляют соглашение между вами и ${OPERATOR_NAME} (далее «мы») об использовании Lexibit. Начиная пользоваться приложением, вы принимаете эти условия. Если вы с ними не согласны, не пользуйтесь приложением.`,
    ],
  sections: [
    {
      heading: `Сервис`,
      paragraphs: [
        `Lexibit: тренажёр слов для изучения иностранных языков. Колоды, интервальные повторения и занятия с преподавателем.`,
        `Приложение бесплатное. Мы развиваем его и можем менять, добавлять и убирать функции.`,
      ],
    },
    {
      heading: `Возраст`,
      paragraphs: [
        `Пользоваться приложением можно с 13 лет.`,
      ],
    },
    {
      heading: `Аккаунт`,
      paragraphs: [
        `Аккаунт необязателен. Вы входите через аккаунт на сторонней платформе (например, Telegram) и отвечаете за доступ к нему и к своим устройствам. Не передавайте другим людям одноразовые коды для привязки устройств.`,
      ],
    },
    {
      heading: `Ваши данные`,
      paragraphs: [
        `Всё, что вы вносите в приложение, остаётся вашим. Вы разрешаете нам хранить и обрабатывать эти данные только в объёме, нужном для работы сервиса, как описано в Политике конфиденциальности.`,
        `Если вы делитесь колодой или заданием с учеником или по ссылке, вы отвечаете за то, что имеете право распространять их содержимое.`,
        `Регулярно сохраняйте резервную копию через экспорт: данные, которые хранятся только на устройстве, пропадут при очистке браузера.`,
      ],
    },
    {
      heading: `Правила использования`,
      paragraphs: [
        `Нельзя:`,
        `• использовать приложение для нарушения закона или прав других людей;`,
        `• размещать через приложение незаконные материалы и данные других людей без их согласия;`,
        `• мешать работе сервиса, обходить ограничения и автоматически отправлять массовые запросы;`,
        `• выдавать себя за другого человека.`,
        `Если вы нарушаете эти условия, мы можем ограничить ваш доступ к облачным функциям.`,
      ],
    },
    {
      heading: `Материалы и ИИ-тьютор`,
      paragraphs: [
        `Переводы и примеры в колодах могут содержать неточности. Если в приложении доступен ИИ-тьютор, его ответы создаёт языковая модель: они могут быть неверными, и их стоит перепроверять.`,
      ],
    },
    {
      heading: `Ответственность`,
      paragraphs: [
        `Приложение предоставляется «как есть». Мы стараемся, чтобы оно работало без сбоев и не теряло данные, но не можем этого гарантировать. В пределах, допустимых законом, мы не отвечаем за косвенные убытки и за потерю данных, которые хранились только на вашем устройстве. Эти условия не ограничивают прав, которые дают вам законы о защите прав потребителей.`,
      ],
    },
    {
      heading: `Прекращение использования`,
      paragraphs: [
        `Вы можете в любой момент перестать пользоваться приложением и удалить аккаунт. Если мы решим закрыть сервис, мы заранее предупредим об этом в приложении и дадим время выгрузить данные.`,
      ],
    },
    {
      heading: `Изменения условий`,
      paragraphs: [
        `Мы можем изменить эти условия и тогда обновим дату редакции вверху страницы. Если вы продолжаете пользоваться приложением после изменений, это значит, что вы принимаете новую редакцию.`,
      ],
    },
    {
      heading: `Контакты`,
      paragraphs: [
        `${OPERATOR_NAME}, ${OPERATOR_CONTACT}.`,
      ],
    },
  ],
};

export const termsEn: PrivacyPolicy = {
  title: `Terms of Use`,
  updated: `Effective 23 September 2026`,
  intro: [
      `These terms are an agreement between you and ${OPERATOR_NAME} ("we", "us") about your use of Lexibit. By using the app, you accept these terms. If you do not agree with them, please do not use the app.`,
    ],
  sections: [
    {
      heading: `The service`,
      paragraphs: [
        `Lexibit is a vocabulary trainer for learning foreign languages: decks, spaced repetition and studying with a tutor.`,
        `The app is free. We keep developing it and may change, add or remove features.`,
      ],
    },
    {
      heading: `Age`,
      paragraphs: [
        `You must be at least 13 to use the app.`,
      ],
    },
    {
      heading: `Your account`,
      paragraphs: [
        `An account is optional. You sign in with an account on a third-party platform (such as Telegram), and you are responsible for keeping that account and your devices secure. Do not share one-time device-linking codes with anyone.`,
      ],
    },
    {
      heading: `Your data`,
      paragraphs: [
        `Everything you put into the app remains yours. You allow us to store and process it only as far as needed to run the service, as described in the Privacy Policy.`,
        `If you share a deck or an assignment with a student or by link, you are responsible for having the right to share its content.`,
        `Export a backup regularly: data kept only on your device is lost when browser data is cleared.`,
      ],
    },
    {
      heading: `Acceptable use`,
      paragraphs: [
        `You must not:`,
        `• use the app to break the law or infringe other people's rights;`,
        `• post unlawful material through the app, or other people's personal data without their consent;`,
        `• disrupt the service, get around its limits or send automated bulk requests;`,
        `• impersonate anyone else.`,
        `If you break these terms, we may restrict your access to the app's cloud features.`,
      ],
    },
    {
      heading: `Content and the AI tutor`,
      paragraphs: [
        `Translations and examples in decks may contain mistakes. If the AI tutor is available in the app, its answers are generated by a language model; they can be wrong and are worth double-checking.`,
      ],
    },
    {
      heading: `Liability`,
      paragraphs: [
        `The app is provided "as is". We work to keep it running and to avoid losing data, but we cannot guarantee either. To the extent permitted by law, we are not liable for indirect losses or for the loss of data that was stored only on your device. Nothing in these terms limits your rights under consumer protection law.`,
      ],
    },
    {
      heading: `Stopping use`,
      paragraphs: [
        `You can stop using the app and delete your account at any time. If we decide to shut the service down, we will announce it in the app in advance and give you time to export your data.`,
      ],
    },
    {
      heading: `Changes to these terms`,
      paragraphs: [
        `We may change these terms; if we do, we will update the effective date at the top of this page. By continuing to use the app after a change, you accept the new version.`,
      ],
    },
    {
      heading: `Contact`,
      paragraphs: [
        `${OPERATOR_NAME}, ${OPERATOR_CONTACT}.`,
      ],
    },
  ],
};
